var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34376 8.98373C1.38735 11.0274 1.40914 12.0493 2.16322 12.8062C2.91731 13.5632 3.96681 13.5895 6.06581 13.6423C7.35946 13.6748 8.64039 13.6748 9.93406 13.6423C12.0331 13.5895 13.0825 13.5632 13.8366 12.8062C14.5907 12.0493 14.6125 11.0274 14.6561 8.98373C14.6701 8.3266 14.6701 7.67333 14.6561 7.01627C14.6125 4.97255 14.5907 3.95071 13.8366 3.19375C13.0825 2.4368 12.0331 2.41043 9.93406 2.35769C8.64039 2.32519 7.35946 2.32519 6.0658 2.35769C3.96681 2.41042 2.91731 2.43679 2.16322 3.19375C1.40914 3.9507 1.38734 4.97255 1.34376 7.0162C1.32975 7.67333 1.32975 8.3266 1.34376 8.98373Z",
    fill: "#4F46E5",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 5.66667L6.62809 6.82627C7.77155 7.50234 8.22861 7.50234 9.37208 6.82627L11.3334 5.66667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2d1ffef1f52d34680dab63906c2ad3f4.svg";
export { ForwardRef as ReactComponent };